<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <h5>Asistente para el registro de Citas</h5>

    <div style="display:flex; justify-content:space-between; align-items:center;
                background-color:#f0f0f0; padding:10px; border-radius:5px;">
      <h4 class="mb-0">Paso 2: Especialidad, fecha y hora</h4>
      <span class="badge-tipo" :class="tipoIngreso === 'Admisión' ? 'badge-tipo--admision' : 'badge-tipo--agendamiento'">
        {{ tipoIngreso }}
      </span>
    </div>

    <hr>

    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body form-card">
          <div class="row">

            <!-- Columna imagen + botones agenda -->
            <div class="col-md-3">
              <img src="../../assets/images/wizardCita/paciente_cita_02.png"
                   alt="Imagen" :style="estiloImagen" />
              <hr>
              <div class="d-flex gap-1">
                <button class="btn btn-light" @click="generarAgenda('dia')"
                        title="Generar Agenda del Día" :disabled="cargandoAgenda">
                  <span class="material-symbols-outlined" style="font-size:24px;color:darkred;">event</span>
                </button>
                <button class="btn btn-light" @click="generarAgenda('mes')"
                        title="Generar Agenda del Mes" :disabled="cargandoAgenda">
                  <span class="material-symbols-outlined" style="font-size:24px;color:darkred;">date_range</span>
                </button>
                <button class="btn btn-light" @click="generarAgenda('anio')"
                        title="Generar Agenda del Año" :disabled="cargandoAgenda">
                  <span class="material-symbols-outlined" style="font-size:24px;color:darkred;">calendar_month</span>
                </button>
              </div>
            </div>

            <!-- Columna formulario -->
            <div class="col-md-9">
              <form>
                <div class="modal-body">

                  <!-- IdCita (solo edición) -->
                  <div class="mb-3" v-if="btnEditar">
                    <div class="row">
                      <div class="col-2">
                        <label class="form-label">IdCita</label>
                      </div>
                      <div class="col-10">
                        <input type="text" class="form-control" v-model="datoCita.idCita" disabled>
                      </div>
                    </div>
                  </div>

                  <!-- Especialidad -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="idEspecialidad" class="form-label">Especialidad</label>
                      </div>
                      <div class="col-10">
                        <select class="form-select" id="idEspecialidad"
                                v-model="datoCita.idEspecialidad" @change="fetchMedicos">
                          <option value="" disabled>-- Seleccione --</option>
                          <option v-for="e in especialidads"
                                  :key="e.idEspecialidad" :value="e.idEspecialidad">
                            {{ e.especialidadNombre }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Médico -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="idMedico" class="form-label">Médico</label>
                      </div>
                      <div class="col-10">
                        <select class="form-select" id="idMedico"
                                v-model="datoCita.idMedico"
                                :disabled="!medicos.length">
                          <option value="" disabled>-- Seleccione --</option>
                          <option v-for="m in medicos"
                                  :key="m.idMedico" :value="m.idMedico">
                            {{ m.nombreCompleto }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Fecha -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="fechaCita" class="form-label">Fecha Cita</label>
                      </div>
                      <div class="col-10">
                        <input type="date" class="form-control" id="fechaCita"
                               v-model="datoCita.fechaCita"
                               :min="minDate" :max="maxDate" required>
                      </div>
                    </div>
                  </div>

                  <!-- Horarios disponibles -->
                  <div class="mb-3" v-if="agendaDisponible.length">
                    <div class="row">
                      <div class="col-2">
                        <label class="form-label">Horario</label>
                      </div>
                      <div class="col-10">
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            v-for="horario in agendaDisponible"
                            :key="horario.idAgenda"
                            type="button"
                            :class="[
                              'btn btn-sm',
                              horario.idAgenda === datoCita.idAgenda
                                ? 'btn-success'
                                : horario.estado !== 0 ? 'btn-info' : 'btn-secondary'
                            ]"
                            @click="seleccionarHorario(horario)"
                            :disabled="horario.estado === 0"
                            :title="horario.estado === 0 ? 'No disponible' : 'Seleccionar'"
                          >
                            {{ horario.horaDesde }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-2 text-muted" style="font-size:0.83rem;"
                       v-else-if="datoCita.idMedico && datoCita.fechaCita">
                    No hay horarios disponibles para la fecha seleccionada.
                  </div>

                  <!-- Hora desde / hasta (readonly, se llena al seleccionar horario) -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="horaDesde" class="form-label">Hora Desde</label>
                      </div>
                      <div class="col-4">
                        <input type="time" class="form-control" id="horaDesde"
                               v-model="datoCita.horaDesde" disabled>
                      </div>
                      <div class="col-2">
                        <label for="horaHasta" class="form-label">Hora Hasta</label>
                      </div>
                      <div class="col-4">
                        <input type="time" class="form-control" id="horaHasta"
                               v-model="datoCita.horaHasta" disabled>
                      </div>
                    </div>
                  </div>

                  <!-- Estado (solo edición) -->
                  <div class="mb-3" v-if="btnEditar">
                    <div class="row">
                      <div class="col-2">
                        <label class="form-label">Estado Cita</label>
                      </div>
                      <div class="col-10">
                        <input type="text" class="form-control"
                               v-model="datoCita.estadoCita"
                               style="text-transform:uppercase" required>
                      </div>
                    </div>
                  </div>

                  <!-- Motivo -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="idMotivoCita" class="form-label">Motivo</label>
                      </div>
                      <div class="col-10">
                        <select class="form-select" id="idMotivoCita"
                                v-model="datoCita.idMotivoCita">
                          <option value="" disabled>-- Seleccione --</option>
                          <option v-for="m in motivosCitas"
                                  :key="m.idMotivoCita" :value="m.idMotivoCita">
                            {{ m.nombre }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Descripción -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="descripcion" class="form-label">Descripción</label>
                      </div>
                      <div class="col-10">
                        <input type="text" class="form-control" id="descripcion"
                               v-model="datoCita.descripcion"
                               style="text-transform:uppercase" required>
                      </div>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="me-auto">
            <button type="button" class="btn btn-primary"
                    @click.prevent="verPersona"
                    style="display:flex; align-items:center;">
              <span class="material-symbols-outlined" style="font-size:32px;">chevron_left</span>
              Anterior
            </button>
          </div>
          <button type="button" class="btn btn-primary"
                  @click.prevent="guardarCita"
                  :disabled="guardando"
                  style="display:flex; align-items:center;">
            {{ guardando ? 'Guardando...' : 'Siguiente' }}
            <span class="material-symbols-outlined" style="font-size:32px; margin-left:8px;">chevron_right</span>
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import { incrementarCitas } from '@/modules/storeHelpers'
import dateFormat from '@/modules/dateFormat.js'
import { validarForm } from '@/modules/validacionesForms.js'
import api        from '@/services/api'
import * as $     from 'jquery'
import swal2      from 'sweetalert2'

window['$']      = $
window['jQuery'] = $

// Convierte 'yyyy-MM-dd' → 'yyyy-MM-ddTHH:mm:ss'
function combinarFechaHora(fecha, hora) {
  return `${fecha}T${hora}:00`
}

// Formatea un Date → 'yyyy-MM-dd'
function formatDate(date) {
  const d = new Date(date)
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, '0'),
    String(d.getDate()).padStart(2, '0'),
  ].join('-')
}

export default {
  components: { Layout, Footer },

  data() {
    return {
      citas:            [],
      datoCita:         {},
      tipoIngreso:      'Agendamiento',   // leído de sessionStorage en mounted
      btnEditar:        false,
      modalWindow:      true,
      p_idPersona:      0,
      p_idEspecialidad: 0,
      p_idMedico:       0,
      medicos:          [],
      motivosCitas:     [],
      especialidads:    [],
      agendaDisponible: [],
      minDate:          '',
      maxDate:          '',
      guardando:        false,   // evita doble submit
      cargandoAgenda:   false,   // bloquea botones mientras genera
      estiloImagen: { width: '200px', height: '200px' },
    }
  },

  watch: {
    // Refresca horarios cuando cambia médico o fecha
    'datoCita.idMedico'(val) {
      if (val && this.datoCita.fechaCita) {
        this.fetchAgendaDisponible(val, this.datoCita.fechaCita)
      }
    },
    'datoCita.fechaCita'(val) {
      if (val && this.datoCita.idMedico) {
        this.fetchAgendaDisponible(this.datoCita.idMedico, val)
      }
    },
  },

  mounted() {
    this.p_idPersona      = this.$route.params.p_idpersona
    this.p_idEspecialidad = this.$route.params.p_idespecialidad
    this.p_idMedico       = this.$route.params.p_idmedico

    // Recuperar tipoIngreso guardado en el paso 1
    this.tipoIngreso = window.sessionStorage.getItem('tipoIngreso') ?? 'Agendamiento'

    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()

    this.setMinMaxDates()
    this.fetchEspecialidads()
    this.fetchMotivosCita()
    this.asignarParametros()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    asignarParametros() {
      if (this.p_idEspecialidad != 0 && this.p_idMedico != 0) {
        this.datoCita.idEspecialidad = parseInt(this.p_idEspecialidad)
        this.fetchMedicos()
        this.datoCita.idMedico = parseInt(this.p_idMedico)
      }
    },

    setMinMaxDates() {
      const hoy      = new Date()
      const en30dias = new Date(hoy.getTime() + 30 * 24 * 60 * 60 * 1000)
      this.minDate   = formatDate(hoy)
      this.maxDate   = formatDate(en30dias)
    },

    validarCampos() {
      const campos     = ['idEspecialidad', 'idMedico', 'fechaCita', 'horaDesde', 'horaHasta', 'descripcion']
      const etiquetas  = ['"Especialidad"', '"Médico"', '"Fecha de la Cita"', '"Hora de Inicio"', '"Hora de Fin"', '"Descripción"']
      return validarForm(this.datoCita, campos, etiquetas)
    },

    verPersona() {
      this.$router.push('/pacientecita01/' + this.p_idPersona)
    },

    async guardarCita() {
      if (this.validarCampos() !== 1) return
      if (this.guardando) return

      this.guardando = true
      try {
        this.datoCita.idEmpresa    = window.sessionStorage.getItem('idEmpresa')
        this.datoCita.idUsuarioReg = window.sessionStorage.getItem('idUsuario')
        this.datoCita.idPersona    = this.p_idPersona
        this.datoCita.tipoIngreso  = this.tipoIngreso   // ← campo proveniente del paso 1

        // Combinar fecha y hora antes de enviar
        const fechaIso = this.datoCita.fechaCita.split('T')[0]
        this.datoCita.fechaCita = combinarFechaHora(fechaIso, this.datoCita.horaDesde)

        const { data } = await api.post('/citas', this.datoCita)
        this.citas              = data
        this.datoCita.idCita   = data.idCita

        incrementarCitas(this.$store)

        // Limpiar tipoIngreso del storage una vez guardado en la cita
        window.sessionStorage.removeItem('tipoIngreso')

        this.$router.push('/pacientecita03/' + data.idCita)

      } catch (error) {
        const msg = error.response?.data?.message ?? 'Intentelo de nuevo.'
        swal2.fire({ icon: 'error', title: 'Error al guardar', text: msg })
      } finally {
        this.guardando = false
      }
    },

    fetchEspecialidads() {
      api.get(`/vwespeemprs/idempresa/${window.sessionStorage.getItem('idEmpresa')}`)
        .then(r => { this.especialidads = r.data })
        .catch(e => console.error('Error fetching especialidades:', e))
    },

    fetchMedicos() {
      if (!this.datoCita.idEspecialidad) return
      // Limpiar selección dependiente
      this.datoCita.idMedico  = null
      this.agendaDisponible   = []
      api.get('/vwmedicos/idempresa-idespecialidad', {
        params: {
          idempresa:      window.sessionStorage.getItem('idEmpresa'),
          idespecialidad: this.datoCita.idEspecialidad,
        },
      })
        .then(r => { this.medicos = r.data })
        .catch(e => console.error('Error fetching médicos:', e))
    },

    fetchMotivosCita() {
      api.get('/vwmotivocitas')
        .then(r => { this.motivosCitas = r.data })
        .catch(e => console.error('Error fetching motivos:', e))
    },

    fetchAgendaDisponible(idMedico, fecha) {
      const formattedDate = typeof fecha === 'string'
        ? fecha.split('T')[0]
        : formatDate(fecha)

      const hoy = formatDate(new Date())
      const now = new Date()

      api.get('/vwagendas/por-fecha', {
        params: { idMedico, fecha: formattedDate },
      })
        .then(r => {
          this.agendaDisponible = r.data
            .filter(item => {
              if (formattedDate > hoy) return true
              if (formattedDate === hoy) {
                const horaActual = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
                return item.horaDesde > horaActual
              }
              return false
            })
            .sort((a, b) => a.horaDesde.localeCompare(b.horaDesde))
        })
        .catch(e => console.error('Error fetching agenda:', e))
    },

    seleccionarHorario(horario) {
      this.datoCita.idAgenda  = horario.idAgenda
      this.datoCita.horaDesde = horario.horaDesde
      this.datoCita.horaHasta = horario.horaHasta
    },

    async generarAgenda(tipo) {
      if (!this.datoCita.idMedico) {
        swal2.fire({
          icon: 'warning',
          title: 'Datos faltantes',
          text: 'Seleccione la especialidad y el médico antes de continuar.',
          confirmButtonText: 'Entendido',
        })
        return
      }
      if (tipo === 'dia' && !this.datoCita.fechaCita) {
        swal2.fire({
          icon: 'warning',
          title: 'Datos faltantes',
          text: 'Seleccione la fecha antes de continuar.',
          confirmButtonText: 'Entendido',
        })
        return
      }

      this.cargandoAgenda = true
      swal2.fire({
        title: 'Procesando...',
        text: 'Generando la agenda, por favor espera.',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => swal2.showLoading(),
      })

      const fechaActual = new Date()
      const endpointMap = { dia: 'generar-dia', mes: 'generar-mes', anio: 'generar-anio' }
      const params = {
        idMedico:   this.datoCita.idMedico,
        agendarSab: 0,
        agendarDom: 0,
        ...(tipo === 'dia' && { fecha: this.datoCita.fechaCita }),
        ...(tipo === 'mes' && { anio: fechaActual.getFullYear(), mes: fechaActual.getMonth() + 1 }),
        ...(tipo === 'anio' && { anio: fechaActual.getFullYear() }),
      }

      try {
        await api.get(`/agendas/${endpointMap[tipo]}`, { params })
        swal2.fire({ icon: 'success', title: '¡Éxito!', text: `Agenda generada correctamente.` })
        // Refrescar horarios si corresponde
        if (tipo === 'dia' && this.datoCita.fechaCita) {
          this.fetchAgendaDisponible(this.datoCita.idMedico, this.datoCita.fechaCita)
        }
      } catch (error) {
        swal2.fire({ icon: 'error', title: 'Error', text: 'No se pudo generar la agenda. Inténtalo de nuevo.' })
        console.error('Error al generar agenda:', error)
      } finally {
        this.cargandoAgenda = false
      }
    },
  },
}
</script>

<style scoped>
.badge-tipo {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 0.82rem;
  font-weight: 600;
}
.badge-tipo--agendamiento { background-color: #a2cf6e; color: #1a3d00; }
.badge-tipo--admision     { background-color: #f7d08a; color: #5a3e00; }
</style>

<style>
.form-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
}
</style>